module.exports = __webpack_public_path__ + "static/media/vf_wknit_core.c75a4f45.svg";